import React, { useMemo } from 'react';
import { GivelifyButton, GivelifyLabel } from '@givelify/givelify-ui';
import { GivelifyModal } from '@givelify/ui';
import { useTranslation } from '../utils/i18n';
import {
    CloseModalButton,
    DoneButtonGroup,
    Info,
    ModalContent,
    ModalTitle,
    Step,
    WorkSteps,
} from './styled';

interface GivelithonWorkModalProps {
    open: boolean;
    onClose: () => void;
}

export const GivelithonWorkModal: React.FCC<GivelithonWorkModalProps> = ({
    open,
    onClose,
}) => {
    const { t, at } = useTranslation();
    const copy = useMemo(
        () => ({
            howWork: t('givelithonModal.howWork'),
            info: t('givelithonModal.info'),
            step1: at('givelithonModal.step1'),
            step2: t('givelithonModal.step2'),
            step3: t('givelithonModal.step3'),
            ok: t('givelithonButton.ok'),
        }),
        [t, at],
    );

    return (
        <GivelifyModal
            fullWidth
            noPadding
            maxWidth="md"
            onClose={onClose}
            open={open}
        >
            <ModalContent data-testid="givelithon-work-modal">
                <ModalTitle>
                    <CloseModalButton onClick={onClose} />
                    <GivelifyLabel text={copy.howWork} variant="heading3" />
                    <GivelifyLabel
                        marginTop={24}
                        text={copy.info}
                        variant="heading3"
                    />
                </ModalTitle>
                <Info>
                    <WorkSteps>
                        <Step>
                            <GivelifyLabel text={copy.step1} />
                        </Step>
                        <Step>
                            <GivelifyLabel text={copy.step2} />
                        </Step>
                        <Step>
                            <GivelifyLabel text={copy.step3} />
                        </Step>
                    </WorkSteps>
                    <DoneButtonGroup>
                        <GivelifyButton
                            data-testid="givelithon-work-modal-ok-button"
                            onClick={onClose}
                            size="large"
                            text={copy.ok}
                            variant="primary"
                        />
                    </DoneButtonGroup>
                </Info>
            </ModalContent>
        </GivelifyModal>
    );
};
